import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/mixins';

export const OpenButton = styled.span`
	cursor: pointer;
	width: 25px;
	height: 25px;
	vertical-align: middle;
	display: inline-block;

	.icon {
		display: inline-block;
	}
`;

export const Menu = styled.div`
	position: fixed;
	right: 0;
	top: 0;
	direction: rtl;
	transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
	visibility: hidden;
	z-index: 10;
	width: 100%;
	height: 100%;

	.lightbox {
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.7);
		position: fixed;
		z-index: 11;
		opacity: 0;
		visibility: hidden;
		transition: ${(p) => p.theme.transition.all};
	}

	.inner {
		position: absolute;
		right: 0;
		top: 0;
		bottom: 0;
		width: 100%;
		max-width: 310px;
		background-color: #fff;
		visibility: hidden;
		transform: translateX(110%);
		padding: 60px 20px 20px;
		z-index: 12;
		transition: 0.6s cubic-bezier(0.19, 1, 0.22, 1);
		box-shadow: 0 4px 30px rgba(8, 29, 41, 0.3);
		border-radius: 15px 0 0 15px;
	}

	&.show {
		visibility: visible;

		.lightbox {
			opacity: 1;
			visibility: visible;
		}

		.inner {
			transform: translateX(0);
			visibility: visible;
		}
	}
`;

export const Nav = styled.ul``;

export const NavItem = styled.li`
	padding: 10px 0;
	margin-bottom: 10px;

	a,
	button {
		display: block;
		${(p) =>
			!p.$btn &&
			css`
				color: ${p.theme.color.black};
			`}
	}

	button {
		cursor: pointer;
		background: transparent;
		border: 0;
		color: ${(p) => p.theme.color.black};
		padding-bottom: 10px;
		padding-top: 20px;
		margin-top: 15px;
		border-top: 1px solid ${(p) => p.theme.color.grayLight};
		padding-right: 0;
		padding-left: 0;
		width: 100%;
		text-align: right;
	}

	${breakpoint.greaterThan('desktop')`
	${(p) =>
		!p.$btn &&
		css`
			a,
			button {
				&:hover {
					color: ${p.theme.color.primary};
				}
			}
		`}
		`}

	.icon {
		width: 30px;
		text-align: center;
		display: inline-block;
		vertical-align: middle;
		margin-left: 15px;
		font-size: 24px;
	}

	.angle-right {
		.icon {
			font-size: 20px;
		}
	}
`;

export const Close = styled.button`
	cursor: pointer;
	width: 60px;
	height: 60px;
	position: absolute;
	left: 0;
	top: 0;
	border: 0;
	background: none;

	.icon {
		font-size: 14px;
	}
`;

export const Header = styled.div`
	position: relative;
	margin-bottom: 30px;
	z-index: 2;

	figure {
		width: 60px;
		height: 60px;
		overflow: hidden;
		border-radius: 100%;
		margin-left: 15px;
		float: right;

		img {
			width: 100%;
			height: 100%;
		}
	}

	aside {
		overflow: hidden;
		text-align: right;
		line-height: normal;

		h4 {
			margin: 5px 0 0;
			font-weight: 500;
		}

		small {
			display: block;
			width: auto;
			clear: both;
			font-weight: 300;
			font-weight: 400;
			color: #868f94;
			margin: 6px 0 0;
		}
	}
`;
